import { render, staticRenderFns } from "./LifestyleModule.vue?vue&type=template&id=5ba70b7a&"
import script from "./LifestyleModule.vue?vue&type=script&lang=ts&"
export * from "./LifestyleModule.vue?vue&type=script&lang=ts&"
import style0 from "./LifestyleModule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports